import { render, staticRenderFns } from "./OrderCompensation.vue?vue&type=template&id=68d1bcb6&scoped=true"
import script from "./OrderCompensation.vue?vue&type=script&lang=js"
export * from "./OrderCompensation.vue?vue&type=script&lang=js"
import style0 from "./OrderCompensation.vue?vue&type=style&index=0&id=68d1bcb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d1bcb6",
  null
  
)

export default component.exports